import React from "react";
import { testimonials } from "../mock";
import { Star, Quote } from "lucide-react";

const Card = ({ t }) => (
  <div className="w-[320px] shrink-0 bg-white rounded-2xl p-6 ring-1 ring-black/5 shadow-sm mx-3">
    <Quote className="w-8 h-8 text-primary/20" />
    <p className="text-sm text-gray-700 mt-2 leading-relaxed line-clamp-5">{t.text}</p>
    <div className="flex items-center gap-3 mt-5 pt-4 border-t border-gray-100">
      <div className="w-11 h-11 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-bold text-lg">
        {t.name[0]}
      </div>
      <div>
        <div className="font-semibold text-gray-900 text-sm">{t.name}</div>
        <div className="flex items-center gap-0.5 mt-0.5">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className="w-3.5 h-3.5 fill-accent text-accent" />
          ))}
        </div>
      </div>
      <span className="ml-auto text-xs text-gray-400">{t.date}</span>
    </div>
  </div>
);

const Testimonials = () => {
  const loop = [...testimonials, ...testimonials];
  return (
    <section className="py-14 md:py-20 bg-gradient-to-b from-secondary/40 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12 text-center mb-10">
        <p className="text-primary font-semibold tracking-wide uppercase text-sm">Testimonials</p>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mt-2">
          Loved by Thousands of Women in Gurugram
        </h2>
        <div className="w-20 h-1 bg-accent rounded-full mx-auto mt-4" />
      </div>

      <div className="marquee-pause relative">
        <div className="flex w-max animate-marquee">
          {loop.map((t, i) => (
            <Card key={i} t={t} />
          ))}
        </div>
        {/* edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-white to-transparent" />
      </div>
    </section>
  );
};

export default Testimonials;
